import { render, staticRenderFns } from "./approvalDataEdit.vue?vue&type=template&id=253c0014&scoped=true"
import script from "./approvalDataEdit.vue?vue&type=script&lang=js"
export * from "./approvalDataEdit.vue?vue&type=script&lang=js"
import style0 from "./approvalDataEdit.vue?vue&type=style&index=0&id=253c0014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c0014",
  null
  
)

export default component.exports